let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3bwa5")).then(() => parcelRequire('k9wdm'));